import { useNavigate } from "react-router-dom";
import { FC, useCallback, useContext, useState, useEffect } from 'react';
import { AppContext } from "../App";
import { UPLOAD_DOC_TYPES } from "../types/types";

export const DocTypeSelect: FC = () => {
    const { accountNumberReq, setAccountNumberReq } = useContext(AppContext);
    const navigate = useNavigate();
    const [stateType, setStateType] = useState('');

    const submitDocType = useCallback(() => {
        stateType === 'CREDITOR' ? navigate('/creditor-file-type') :
            stateType === 'INCOME' ? navigate('/income-file-type') : navigate('/upload');
    }, [stateType, navigate]);

    useEffect(() => {
        !accountNumberReq.uuid && navigate('/');
    });

    return (
        <div className="page">

            <div className="container">

                <h1 className="page__title u-m__b--l">Welcome</h1>
                <h2 className="u-m__b--l">Please note, selecting the right category will ensure your document reaches the correct place and is processed as efficiently as possible.</h2>

                <form onSubmit={e => { e.preventDefault(); submitDocType(); }}>

                    {UPLOAD_DOC_TYPES.map(fileType => (
                        <div className="type-radio-option u-m__b--l" key={fileType.type}>
                            <input
                                className={`${fileType.css} u-m__r`}
                                type="radio"
                                name="fileType"
                                value={fileType.type}
                                required
                                checked={stateType === fileType.type}
                                onChange={(e) => {
                                    setStateType(fileType.type);
                                    setAccountNumberReq({ ...accountNumberReq, fileTye: fileType.type });
                                }
                                }
                            />
                            <label className="form__label">
                                <p className="type-radio__option-title">{fileType.heading}</p>
                                <p>{fileType.description}</p>
                            </label>
                        </div>
                    ))}

                    <input className="btn" type="submit" value="Continue" disabled={stateType === ''} />
                </form>
            </div>
        </div >

    );
}
